var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8581 17V12.1429H16.2869L12.0009 7.28571L7.71484 12.1429H11.1437V17H6.85763V16.9595C6.71362 16.9676 6.57647 17 6.42903 17C4.72395 17 3.0887 16.3603 1.88302 15.2217C0.677342 14.0831 0 12.5388 0 10.9286C0 7.81352 2.49446 5.27486 5.69526 4.92676C5.97589 3.54133 6.75896 2.29155 7.90978 1.39238C9.06059 0.493209 10.5072 0.00085488 12.0009 0C13.4947 0.000789551 14.9416 0.493086 16.0927 1.39224C17.2438 2.29138 18.0272 3.5412 18.3082 4.92676C21.509 5.27486 24 7.81352 24 10.9286C24 12.5388 23.3227 14.0831 22.117 15.2217C20.9113 16.3603 19.2761 17 17.571 17C17.427 17 17.2881 16.9676 17.1424 16.9595V17H12.8581Z",
    fill: "#4C1E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.d6a5ccc690641f5968f0eb44c77f0f30.svg";
export { ForwardRef as ReactComponent };